import React from 'react'
import { withFirebase } from './components/Firebase';
import * as emailjs from 'emailjs-com' 
import CustomNavbar from './components/CustomNavBar'
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';


class Success extends React.Component {
  constructor(props) {
    super(props);

  }

componentDidMount(){


}

  render() {

    return( 
    <div style={{height:'100%'}}>
        <GenerateLicense/>
    </div>
    )

  }
}



class GenerateLicenseBase extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      waiting: false,
      loading: true,
      success: false,
      message: '',
      licences: [],
    };

  }

  componentDidMount() {

    this.setState({ loading: true });

    this.props.firebase.licenses().on('value', snapshot => {
      const licenseObject = snapshot.val();

      const licenseList = Object.keys(licenseObject).map(key => ({
        ...licenseObject[key],
        uid: key,
      }));
      
      let id = this.getUrlVars()["id"];
      let license = {};
      if(id){
        license = licenseList.find(item => item.uid.includes(id));
        if(license){
          if(!license.isLicensed){
            this.setState({ waiting: true });
            this.generateLicense(license);
            license.isLicensed = true;
            this.props.firebase.license(id).set(license);      
          }else{
            if(!this.state.waiting){
              console.log("Uid already licensed!!!!")
              this.licenseCallback(false, "Uid already licensed");
            }
          }
        }
        else{
          this.licenseCallback(false, "License not found in database");
          console.log("License not found in database");
        }
      }else{
        this.licenseCallback(false, "Uid could not be found");
        console.log("id not available in URL")
      }
 


    });

  }

licenseCallback = (success, message) =>{

  this.setState({
    loading: false,
    success: success,
    message: message,
  });

}

getUrlVars = () => {
    let vars = {};
    let parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}

generateLicense = async(licenseInfo) => {

  const productId = '36692782-5bdf-4afc-9684-01b10536965a';

      // create license
      const licenseBody = {
        productId: productId,
        metadata: []
    };

    Object.keys(licenseInfo).map((key,index) => {
      licenseBody.metadata.push({ key: key, value: licenseInfo[key] , visible: true });
    });

    const self = this;
    

}

   sendMail = (key, email, boatname) => {

    let parameters = {
      license: key,
      boatname: boatname,
      email: email,
    }

    const self = this;

    emailjs.send("gmail", "template_83I42r8G_clone", parameters,"user_AlqmLTPVcKjA5OQjVTOoQ")
      .then(function (response){
        //console.log("Email Send, ", response.status);
        self.licenseCallback(true, parameters);
        self.setState({ waiting: false });

    }, function (err){
        self.licenseCallback(true, parameters);
        console.log("Send failed! ", err)
        this.setState({ waiting: false });
    })

   }


  render() {

    const { loading , success, message} = this.state;

    const testLoading = true;

    /*
      {loading && 
        <div style={{padding:'50px', textAlign:'center'}}>         
            <CircularProgress />
            <Typography variant="subtitle1" style={{marginTop:'15px',paddingBottom:'5px', color:'black', textAlign:'center'}}>
                Generating license...
            </Typography>  
        </div>
      }
    */

    let render;
    if(loading){
      render = (
        <div style={{padding:'50px', textAlign:'center'}}>         
            <CircularProgress />
            <Typography variant="subtitle1" style={{marginTop:'15px',paddingBottom:'5px', color:'black', textAlign:'center'}}>
                Generating license...
            </Typography>  
        </div>
      );
    }else{
      if(!success){
        render = (
          <div style={{padding:'20px', textAlign:'center'}}>     
            <Typography variant="h5" style={{marginTop:'15px',paddingBottom:'5px', color:'black', textAlign:'center'}}>
                Failed to generate license! 
            </Typography>
            <Typography variant="subtitle1" style={{marginTop:'15px',paddingBottom:'5px', color:'red', textAlign:'center'}}>
                {"Error: " + message}
            </Typography>
            <Typography variant="h6" style={{marginTop:'15px',paddingBottom:'5px', color:'black', textAlign:'center'}}>
                Please contact truenorthsailingsoftware@gmail.com
            </Typography>
          </div>      
        );
      }else{
        render = (
            <div style={{padding:'20px', textAlign:'center'}}> 
            <Typography variant="h5" style={{marginTop:'15px',paddingBottom:'5px', color:'black', textAlign:'center'}}>
                {"Successfully generated license for " + message.boatname } 
            </Typography>
            <Typography variant="h4" style={{marginTop:'20px',paddingBottom:'20px', color:'blue', textAlign:'center'}}>
                {message.license}
            </Typography>
            <Typography variant="subtitle1" style={{marginTop:'20px',paddingBottom:'5px', color:'black', textAlign:'center'}}>
                {"An email has been send to " + message.email + " with license and installation instructions."}
            </Typography>
            <Typography variant="subtitle1" style={{marginTop:'5px',paddingBottom:'5px', color:'black', textAlign:'center'}}>
                {"Please contact truenorthsailingsoftware@gmail.com for any further help."}
            </Typography>
            </div>      
        );
      }
    }

    return( 
      <div style={{height:'100%'}}>
      <div style={{minHeight:'92vh'}}>
      <CustomNavbar logo={true}></CustomNavbar>

      <Grid container direction="column" justify={'center'} alignItems={'center'} style={{marginLeft:'-10px' ,paddingTop:'30px'}}>
        <Typography variant="h4" style={{marginTop:'5px',paddingBottom:'5px', color:'black', maxWidth:"80%", textAlign:'center'}}>
           Payment successful.
        </Typography>  
        {render}
      </Grid>
      </div>
 
      <div style={{minHeight:'8vh', boxShadow:'0 0px 12px 0 rgba(0, 0, 0, 0.4), 0 0px 20px 0 rgba(0, 0, 0, 0.4)', backgroundColor:'#313131'}}>
      <Grid container direction="row" justify={'center'} alignItems={'center'} style={{height:'8vh'}}>
      <Typography variant="body2" style={{color:'white'}}>
                    Contact us at truenorthsailingsoftware@gmail.com | +27 84 600 6091
      </Typography>
      </Grid>
      </div> 


      </div>
    )
  }
}

const GenerateLicense = withFirebase(GenerateLicenseBase);

export default Success

export { GenerateLicense };




/*
allowVmActivation: false
allowedActivations: 1
allowedClockOffset: 180
allowedCountries: []
allowedDeactivations: 0
allowedFloatingClients: 0
allowedIpAddresses: []
createdAt: "2019-06-11T21:40:01.6823548Z"
disallowedCountries: []
disallowedIpAddresses: []
expirationStrategy: "immediate"
expiresAt: "2019-06-25T22:03:21.6823548Z"
fingerprintMatchingStrategy: "fuzzy"
id: "1cccc948-15b1-4d27-92ce-fe6de232b905"
key: "F04A45-5E5696-4EC695-64F9DB-1F034E-70BA7C"
leaseDuration: 0
leasingStrategy: "per-machine"
metadata: Array(4)
0: {visible: true, key: "boatname", value: "Phoenix 11"}
1: {visible: true, key: "email", value: "shane.elliott@northsails.com"}
2: {visible: true, key: "isLicensed", value: "true"}
3: {visible: true, key: "uid", value: "_djthe3k036f"}
length: 4
__proto__: Array(0)
meterAttributes: []
notes: null
productId: "36692782-5bdf-4afc-9684-01b10536965a"
requireAuthentication: false
reseller: null
revoked: false
serverSyncGracePeriod: 1211000
serverSyncInterval: 3600
suspended: false
tags: []
totalActivations: 0
totalDeactivations: 0
type: "node-locked"
updatedAt: "2019-06-11T21:40:01.6823599Z"
user: null
userLocked: false
validity: 1211000
__proto__: Object

*/